import React from 'react'
import { Controller, Control } from 'react-hook-form'
import { IconButton, Typogaphy } from 'vnetwork-ui'
import TextEditorCustomize from '@/components/TextEditorCustomize'
import HelpIcons from '@/icons/HelpIcons'
import { useAppStore } from '@/stores/useAppStore'
import internalRootCause from '@/modules/Ticket/help/ticket-internal-root-cause-help.md'
import internalRemedialMeasures from '@/modules/Ticket/help/ticket-internal-remedial-measures-help.md'
import internalAvoid from '@/modules/Ticket/help/ticket-internal-avoid-help.md'
import { useTranslation } from 'react-i18next'
interface TicketInternalProps {
    control: Control<any>
    viewOnly?: boolean
}

const TicketInternal: React.FC<TicketInternalProps> = ({
    control,
    viewOnly = false,
}) => {
    const { t } = useTranslation()
    const { setIsShowHelp, setHelpContent, isShowHelp } = useAppStore()
    return (
        <div className="space-y-3">
            <div>
                <div className="flex items-center mb-1">
                    <Typogaphy size="small" className="mb-1">
                        {t('ticket-internal-root-cause')}
                    </Typogaphy>
                    <IconButton
                        size="small"
                        className="mb-1"
                        onClick={() => {
                            setIsShowHelp(!isShowHelp)
                            setHelpContent(internalRootCause)
                        }}
                    >
                        <HelpIcons className="text-black" />
                    </IconButton>
                </div>
                <Controller
                    control={control}
                    name="ticket_internal_root_cause"
                    render={({ field, fieldState: { error } }) => {
                        const message =
                            error &&
                            typeof error === 'object' &&
                            'text' in (error as any)
                                ? (error as any).text?.message
                                : undefined

                        return (
                            <div>
                                <TextEditorCustomize
                                    disabled={viewOnly}
                                    disabledAttachments={true}
                                    value={
                                        typeof field.value === 'string'
                                            ? {
                                                  text: field.value,
                                                  attachments: [],
                                              }
                                            : field.value || {
                                                  text: '',
                                                  attachments: [],
                                              }
                                    }
                                    onChange={(val) => field.onChange(val)}
                                    imagePrefix="tickets"
                                />
                                {message && (
                                    <p className="text-red-500 text-sm mt-1">
                                        {message}
                                    </p>
                                )}
                            </div>
                        )
                    }}
                />
            </div>

            <div>
                <div className="flex items-center mb-1">
                    <Typogaphy size="small" className="mb-1">
                        {t('ticket-internal-remedial-measures')}
                    </Typogaphy>
                    <IconButton
                        size="small"
                        className="mb-1"
                        onClick={() => {
                            setIsShowHelp(!isShowHelp)
                            setHelpContent(internalRemedialMeasures)
                        }}
                    >
                        <HelpIcons className="text-black" />
                    </IconButton>
                </div>
                <Controller
                    control={control}
                    name="ticket_internal_remedial_measures"
                    render={({ field, fieldState: { error } }) => {
                        const message =
                            error &&
                            typeof error === 'object' &&
                            'text' in (error as any)
                                ? (error as any).text?.message
                                : undefined

                        return (
                            <div>
                                <TextEditorCustomize
                                    disabled={viewOnly}
                                    disabledAttachments={true}
                                    value={
                                        typeof field.value === 'string'
                                            ? {
                                                  text: field.value,
                                                  attachments: [],
                                              }
                                            : field.value || {
                                                  text: '',
                                                  attachments: [],
                                              }
                                    }
                                    onChange={(val) => field.onChange(val)}
                                    imagePrefix="tickets"
                                />
                                {message && (
                                    <p className="text-red-500 text-sm mt-1">
                                        {message}
                                    </p>
                                )}
                            </div>
                        )
                    }}
                />
            </div>

            <div>
                <div className="flex items-center mb-1">
                    <Typogaphy size="small" className="mb-1">
                        {t('ticket-internal-avoid')}
                    </Typogaphy>
                    <IconButton
                        size="small"
                        className="mb-1"
                        onClick={() => {
                            setIsShowHelp(!isShowHelp)
                            setHelpContent(internalAvoid)
                        }}
                    >
                        <HelpIcons className="text-black" />
                    </IconButton>
                </div>
                <Controller
                    control={control}
                    name="ticket_internal_avoid"
                    render={({ field, fieldState: { error } }) => {
                        const message =
                            error &&
                            typeof error === 'object' &&
                            'text' in (error as any)
                                ? (error as any).text?.message
                                : undefined

                        return (
                            <div>
                                <TextEditorCustomize
                                    disabled={viewOnly}
                                    disabledAttachments={true}
                                    value={
                                        typeof field.value === 'string'
                                            ? {
                                                  text: field.value,
                                                  attachments: [],
                                              }
                                            : field.value || {
                                                  text: '',
                                                  attachments: [],
                                              }
                                    }
                                    onChange={(val) => field.onChange(val)}
                                    imagePrefix="tickets"
                                />
                                {message && (
                                    <p className="text-red-500 text-sm mt-1">
                                        {message}
                                    </p>
                                )}
                            </div>
                        )
                    }}
                />
            </div>
        </div>
    )
}

export default TicketInternal
